import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

type Props = {
  open: boolean;
  onClose: () => void;
  onConfirm: (dateIso: string) => void;
};

function todayIso(): string {
  const t = new Date();
  const y = t.getFullYear();
  const m = String(t.getMonth() + 1).padStart(2, '0');
  const d = String(t.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

const AssignmentDateInputModal: React.FC<Props> = ({ open, onClose, onConfirm }) => {
  const [value, setValue] = useState(todayIso);

  useEffect(() => {
    if (open) setValue(todayIso());
  }, [open]);

  if (!open) return null;

  return createPortal(
    <div className="cp-apn-date-overlay" role="presentation" onClick={onClose}>
      <div
        className="cp-apn-date-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="cp-apn-date-title"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 id="cp-apn-date-title" className="cp-apn-date-title">
          추가 날짜 선택
        </h2>
        <input
          className="cp-apn-create-date-input"
          type="date"
          value={value}
          onChange={(e) => setValue(e.target.value)}
        />
        <div className="cp-apn-create-buttons">
          <button type="button" className="cp-apn-create-btn-cancel" onClick={onClose}>
            취소
          </button>
          <button
            type="button"
            className="cp-apn-create-btn-save"
            disabled={!value}
            onClick={() => {
              if (!value) return;
              onConfirm(value);
              onClose();
            }}
          >
            확인
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default AssignmentDateInputModal;
